import { render, staticRenderFns } from "./ItemEditDialog.vue?vue&type=template&id=0e6c5168&scoped=true"
import script from "./ItemEditDialog.vue?vue&type=script&lang=js"
export * from "./ItemEditDialog.vue?vue&type=script&lang=js"
import style0 from "./ItemEditDialog.vue?vue&type=style&index=0&id=0e6c5168&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e6c5168",
  null
  
)

export default component.exports